import Drawer from 'common/drawer';
import _ from 'lodash';
import { useParsedQueryString, useUpdatedTo } from 'projects/project-selector/hooks';
import { useHistory } from 'react-router-dom';
import { useQueryGetGCPProjects } from 'hooks/queries';
import TreeView from 'projects/project-selector/index';
import Error500 from 'components/error-500';
import Button from 'react-bootstrap/Button';

export const routeParamsToCloseImportProjectsDrawer = _.constant({ import: undefined, view: undefined });
export const routeParamsToOpenImportProjectsDrawer = _.constant({ import: 'open', view: undefined });

export const useIsImportProjectsDrawerOpen = () => (useParsedQueryString()?.import === routeParamsToOpenImportProjectsDrawer()?.import);

const errorState = (query) => !query?.isSuccess && !query?.isFetching && query?.error;

export const loadingState = (query) => {
  if (query?.isSuccess) {
    return false;
  }
  return !!query?.isFetching || !!query?.isLoading;
};

export const ProjectImporterDrawer = () => {
  const query = useQueryGetGCPProjects();
  const history = useHistory();
  const isDrawerOpen = useIsImportProjectsDrawerOpen();
  const toClose = useUpdatedTo(routeParamsToCloseImportProjectsDrawer());
  const close = () => history.replace(toClose);
  const loading = loadingState(query);
  const error = errorState(query);
  return (
    <Drawer title="Import Projects" loading={loading} handleClick={close} show={isDrawerOpen}>
      {() => (error ? (
        <Error500 message={(
          <>
            <p>
              There was a problem retrieving the list of projects from GCP.
            </p>
            <p>
              <Button type="button" onClick={query?.refetch} variant="primary">Retry</Button>
            </p>
          </>
        )}
        />
      ) : (<TreeView />))}
    </Drawer>
  );
};
